<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div v-bind:class="[{ busy: busy }, 'opacity-transition']">
        <b-row class="my-4">
            <b-col>
                <div class="input-group">
                    <b-input-group-prepend is-text><span class="icon-search"></span></b-input-group-prepend>
                    <b-form-input
                        style="background-color: #F1F1F1; border: none;"
                        class="secondary"
                        id="filter"
                        name="filter"
                        size="lg"
                        type="text"
                        placeholder="article name / number / description"
                        :value="filterString"
                        v-debounce:500="onFilter"
                    ></b-form-input>
                    <b-button size="lg" @click="openSidebar()"
                              :disabled="!currentFilterList ||currentFilterList.length === 0" class="ml-2"
                              variant="primary">Filter &
                        Category <i
                            class="fal fa-inline fa-sliders-h"></i></b-button>
                    <dropdown-nav key="sort" toggler-class="header-nav-item"
                                  style="flex: none !important; z-index: 1;"
                                  distance-y="sm"
                                  arrow="center">
                        <template slot="label">

                            <b-button size="lg" class="ml-2"
                                      variant="secondary">Sort By
                                <i v-if="currentSortDirection === 'DESC'"
                                   class="fal fa-inline fa-sort-amount-down-alt"></i> <i v-else
                                                                                         class="fal fa-inline fa-sort-amount-up-alt"></i>
                            </b-button>

                        </template>
                        <b-nav vertical class="sort-nav p-3">
                            <b-nav-item :key="key"
                                        exact
                                        :active="currentSort === key"
                                        :to="{ name: 'customer',  query: { ...$route.query, sort: key, sortDirection: currentSortDirection === 'DESC' ? 'ASC' : 'DESC' } }"
                                        v-for="(item, key) in sortOptions">
                                <span style="font-size: 12px;">{{ item.label }}</span>
                            </b-nav-item>
                        </b-nav>
                    </dropdown-nav>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <pb-article-filter v-if="currentFilterList && currentFilterList.length > 0"
                                   key="uniqueKey"
                                   ref="sidebar"
                                   @filteredArticleCount="prefetchArticleCount"
                                   :current-filter-list="currentFilterList"
                                   :count="count"
                                   :busy="loadingFilter"
                                   :category="category">
                </pb-article-filter>
                <b-row v-if="activeFilterItems && activeFilterItems.length > 0" class="mb-4" align-v="center">
                    <b-col>
                        <b-row>
                            <b-col md="4" :key="filter.key" v-for="(filter) in activeFilterItems">
                                <h6>{{ $t(`filter_key_${filter.key}`) }}</h6>
                                <div :key="filterItem.id + index" v-for="(filterItem, index) in filter.items"
                                     class="filter-btn active" block active pill>
                                    <b-button v-if="filterItem.active" @click="openSidebar()"
                                              class="filter-btn" pill>
                                        {{ filterItem.label || $t(`filter_item_label_${filterItem.id}`) }}
                                    </b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <b-row>
                            <b-col>
                                <b-button @click="$refs.sidebar.reset()">
                                    <i class="fal fa-times"></i> REMOVE FILTER
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row align-v="center">
                    <b-col>
                        <div class="overflow-auto">
                            <b-pagination-nav v-if="filteredArticles && filteredArticles.length" v-model="currentPage" :link-gen="linkGen"
                                              :number-of-pages="Math.ceil(filteredArticles.length / pageSize)"
                                              use-router></b-pagination-nav>
                        </div>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <pb-btn v-if="category && category.type != 'CUSTOMER_SHOP'" :busy="loadingExport" size="sm"
                                @click.native="exportC()"
                                :disabled="exportInProgress" variant="link"
                                icon="fa-envelope">
                            Price List
                        </pb-btn>
                    </b-col>
                </b-row>
                <transition name="fade">
                    <div :key="currentPage">
                        <component :is="typeComponent" class="d-md-flex"
                                   primary :article="article" :category="category"
                                   v-bind="typeComponentProperties"
                                   @addSampleItem="addSampleItem"
                                   v-for="(article) in visibleArticleList"
                                   :key="article.id"></component>
                    </div>
                </transition>
                <div class="overflow-auto">
                    <b-pagination-nav v-if="filteredArticles && filteredArticles.length" v-model="currentPage" :link-gen="linkGen"
                                      :number-of-pages="Math.ceil(filteredArticles.length / pageSize)"
                                      use-router></b-pagination-nav>
                </div>
                <sample-confirmation-modal :category="category"
                                           id="sample-confirmation-modal"
                                           ref="sampleConfirmationModal"/>

                <b-modal ok-only ref="export-confirmation">
                    <p class="my-4">{{ $t("export_article_list_confirmation") }}</p>
                </b-modal>
            </b-col>
        </b-row>
    </div>
</template>


<script>

import CustomerCategoryArticle from "../../Article/Customer/CustomerCategoryArticle";
import CustomerCategoryArticleMobile from "../../Article/Customer/CustomerCategoryArticleMobile";
import CategoryApi from "@shared/_api/category";
import CustomerCategoryArticleBasic from "../../Article/Customer/CustomerCategoryArticleBasic";
import CategoryBase from "../CategoryBase";
import ArticleFilter from "../../../components/article/ArticleFilter";
import DropdownNav from "../../../../components/DropdownNav";
import {mapGetters} from "vuex";
import SampleConfirmationModal from "../../../components/SampleConfirmationModal";
import moment from 'moment';
import Spinner from "@client/src/viewsShop/components/ui/Spinner";

export default {
    name: 'pb-customer-category',
    extends: CategoryBase,
    data: function () {
        return {
            moment: moment,
            currentPageOrderList: 1,
            loadingOrderList: false,
            orderList: [],
            orderListFilter: null,
            pageSize: 10,
            loadingExport: false,
            sampleRequest: null,
            filterConfig: ['category'],
            selectedOrderType: ['PRODUCTION', 'SAMPLE'],
            customerOrderNumberFilter: null,
            articleFilter: null,
            customerArticleFilter: null
        }
    },
    components: {
        'customer-category-article': CustomerCategoryArticle,
        'customer-category-article-mobile': CustomerCategoryArticleMobile,
        'customer-category-article-basic': CustomerCategoryArticleBasic,
        'pb-article-filter': ArticleFilter,
        'dropdown-nav': DropdownNav,
        'sample-confirmation-modal': SampleConfirmationModal,
        'spinner': Spinner
    },
    computed: {
        ...mapGetters('media', ['isDesktop']),
        orders: function () {
            return this.$_.orderBy(this.orderList.filter(order => {
                let orderTypeTest = [...this.selectedOrderType];
                if (orderTypeTest.includes('PRODUCTION')) {
                    orderTypeTest.push('RETRIEVAL');
                }

                return (orderTypeTest ? orderTypeTest.includes(order.orderType) : true)
                    && (this.articleFilter ? order.article.includes(this.articleFilter) : true)
                    && (this.customerOrderNumberFilter ? order.customerOrderNumber.includes(this.customerOrderNumberFilter) : true)
                    && (this.customerArticleFilter ? order.customerArticle.includes(this.customerArticleFilter) : true);
            }), [this.rowClass, 'confirmedDateUpdatedAt'], ['asc', 'desc']);
        },
        filteredArticles: function () {
            return this.category ? this.applyFilter(this.category, true) : [];
        },
        typeComponent() {
            if (this.isDesktop) {
                return this.category && this.category.type === 'CUSTOMER_SHOP' ? 'customer-category-article' : 'customer-category-article-basic';
            }
            return this.category && this.category.type === 'CUSTOMER_SHOP' ? 'customer-category-article-mobile' : 'customer-category-article-basic';
        },
        typeComponentProperties() {
            if (this.typeComponent === 'customer-category-article-basic') {
                return {addSampleItem: this.addSampleItem}
            }
            return {}
        }
    },
    created: function () {
        let route = this.$route;
        if (route.params.searchString) {
            this.filterString = route.params.searchString;
        }

        if (Number(route.params.id) !== Number(route.params.id)) {
            this.fetchCategory(route.params.id);

            if (route.query.page) {
                this.currentPage = parseInt(route.query.page);
            } else {
                this.currentPage = 1;
            }


        }
    },
    methods: {
        addSampleItem(sampleRequest) {
            this.$refs.sampleConfirmationModal.show(sampleRequest);
        },
        onFilter(value) {
            this.filterString = value;
        },
        exportC() {
            this.loadingExport = true;
            CategoryApi.customerCategoryExport(this.category.id, this.filteredArticles.map(i => i.id)).then(() => {
                this.$refs['export-confirmation'].show();
                this.exportInProgress = true;
            }).finally(() => {
                this.loadingExport = false;
            });

        },
        fetchCategory(id, queryparam) {
            this.busy = true;

            CategoryApi.customerCategoryById(id, queryparam).then(category => {
                this.category = category;

                // window.gtag('set', 'page', '/customer/' + category.name)
                // window.gtag('send', 'pageview');
                this.$tracker.trackView({label: category.name, type: 'CATEGORY'}, this.user);
                this.count = this.filteredArticles.length;

            }).finally(() => {
                this.busy = false;
            });

            this.fetchFilter(id, queryparam);
        },
        prefetchArticleCount(queryParam) {
            this.loadingFilter = true;
            CategoryApi.customerCategoryById(this.category.id, queryParam).then(category => {
                this.count = this.applyFilter(category).length;
            }).finally(() => {
                this.loadingFilter = false;
            });
        },
    },
    watch: {
        filterString: function () {
            this.currentPage = 1;
        }
    }
}
</script>
